module.exports = __webpack_public_path__ + "static/media/acai_berry_scrub.11ea768a.png";